/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Comm_TimezoneInputs */

const cs_clients_comm_timezone = /** @type {(inputs: Clients_Comm_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Časové pásmo`)
};

const en_clients_comm_timezone = /** @type {(inputs: Clients_Comm_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timezone`)
};

/**
* | output |
* | --- |
* | "Timezone" |
*
* @param {Clients_Comm_TimezoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_comm_timezone = /** @type {((inputs?: Clients_Comm_TimezoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Comm_TimezoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_comm_timezone(inputs)
	return cs_clients_comm_timezone(inputs)
});